import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { formatDateWithMonth, formatFileSize } from 'ns_libs/formatter';
import React, { useCallback } from 'react';
import {
    Card,
    CardBody,
} from 'reactstrap';
import { checkIfIsFile, getFileIcon, iconColorByFilenameExtension } from '../../helpers';
import { DealDirectoryItem } from '../../types';
import './FileTileCard.scss';
import DocumentActionOptions from './DocumentActionOptions';

interface IFileTileCardProps {
    item: DealDirectoryItem;
    onSelectDocument: (id: number) => void;
    onToggle: (directoryId: number) => void;
    onDelete: (item: DealDirectoryItem) => void;
    onEdit: (item: DealDirectoryItem) => void;
    onDocumentEdit: (id: number) => void;
}

const FileTileCard: React.FC<IFileTileCardProps> = ({
    item, onSelectDocument, onToggle, onDelete, onEdit, onDocumentEdit,
}) => {
    const isFile = checkIfIsFile(item);
    const handleDownload = useCallback(() => {
        if ('s3Url' in item && item.s3Url) window.open(item.s3Url, '_blank');
    }, [item]);

    const handleRowClick = (e: React.MouseEvent) => {
        if ((e.target as HTMLElement).closest('.FileTileCard__dropdown')) return;
        if (isFile) {
            onSelectDocument(item.id);
        } else if (item.directoryId) onToggle(item.directoryId);
    };

    const handleEditClick = (e: React.MouseEvent) => {
        if (isFile) {
            onDocumentEdit(item.id);
        } else {
            onEdit(item);
        }
    };

    return (
        <Card
            onClick={handleRowClick}
            className={classNames('FileTileCard__doc-card p-0 m-0', { 'heap-deal-documents-click-document': isFile })}
        >
            <DocumentActionOptions onDownload={handleDownload} isFile={isFile} onDelete={onDelete} onEdit={handleEditClick} />
            <CardBody className="d-flex flex-column justify-content-center">
                <div className="d-flex flex-column justify-content-center">
                    <div className="d-flex flex-column align-items-center">
                        <FontAwesomeIcon
                            className={classNames(
                                `rounded FileTileCard__${isFile && 'extension' in item ? iconColorByFilenameExtension[item.extension.toLowerCase()] : ''}`,
                                {
                                    'FileTileCard__icon p-2': isFile,
                                    'FileTileCard__big-icon': !isFile,
                                },
                            )}
                            icon={getFileIcon({ fileFormat: 'extension' in item ? item.extension : undefined, isExpanded: false })}
                            color="white"
                        />
                        {isFile && <small className="m-0 mt-2 mb-1 text-muted small">{formatFileSize(item.size)}</small>}
                    </div>
                    <p className="text-truncate text-white mb-0">
                        {isFile ? item.name : item.directoryName}
                    </p>

                    {isFile && (
                        <small className="text-muted m-0">
                            {`Uploaded ${formatDateWithMonth(item.updatedAt)}`}
                        </small>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default FileTileCard;
